/**
 * @file layout 状态
 */

// eslint-disable-next-line
// @ts-nocheck
export const useLayoutStore = defineStore('layoutStore', {
  state: () => ({
    // header悬浮定位
    headerFixed: false,
    // 当前路由布局名称
    routeLayout: 'default',
    // 当前route配置参数
    routeProps: <any>{},
    // 当前路由布局class名称
    layoutClass: <any>{},
    // 页面标题
    pageTitle: '',
    pageKeywords: '',
    pageDescription: '',
    // 页面宽度  默认0的时候会有个null报错
    contentWidth: 1200,
    // 记录当前页面的meta
    routeMeta: <any>{},
    direction: <string>'ltr'
  }),
  actions: {
    initRouteLayout(params: any) {
      if (params) {
        this.routeLayout = params.layout || 'default';
        this.routeProps = params.props || {};
        this.layoutClass = params?.class;
        this.routeMeta = params; // 记录当前页面的meta
      }

      // header默认固定
      this.headerFixed = false;
    }
  }
});
